import axios from 'axios';
import Cookies from 'js-cookie';

import { MindsightAuthToggles } from '../types';

export const MindsightAuthSystemApi = {
  getAuthToggles: async (authSystemUrl: string): Promise<MindsightAuthToggles> => {
    const basename = window.location.pathname.split('/')[1];
    const api = axios.create({
      baseURL: `${cleanUrlPath(authSystemUrl)}/${basename}`,
      timeout: 100000,
      headers: {
        'X-CSRFToken': Cookies.get('csrftoken') || '',
        'Content-Type': 'application/json',
      },
      withCredentials: true,
    });
    try {
      const response = await api.get(`/api/v1/auth_toggles/`);
      return {
        t001_use_new_home_design: response.data.t001_use_new_home_design ?? false,
        t004_hide_logout_sankhyarh: response.data.t004_hide_logout_sankhyarh ?? false,
        enable_sankhya_menu: response.data.enable_sankhya_menu ?? false,
      };
    } catch (e) {
      return {
        t001_use_new_home_design: false,
        t004_hide_logout_sankhyarh: false,
        enable_sankhya_menu: false,
      };
    }
  },
};

const cleanUrlPath = (url: string) => (url.charAt(url.length - 1) === '/' ? url.slice(0, -1) : url);
